import React, {Component} from 'react';
import Publicaciones from './';
import Detalle from './Detalle'

class WithData extends Component {
  constructor(){
    super();
    this.state = {
      data : "",
      publicOMC: "",
      publicPI: ""
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Publicaciones", requestOptions)
    .then(response=>response.json())
    .then(data=>{

      var arrPublicOMC = [];
      var arrPublicPI = [];
      var datos = [];
      let datosSinFiltrar = data.records.filter(record => record.fields.Activo === true).reverse();
      
      datosSinFiltrar.forEach(element => {
        if (element.fields.categoria){
          if (element.fields.categoria == "omc"){
            arrPublicOMC.push(element)
          } else if (element.fields.categoria == "pi") {
            arrPublicPI.push(element)
          } else {
            datos.push(element)
          }
        } else {
          datos.push(element)
        }

      });

      this.setState({
        data: datos,
        publicOMC: arrPublicOMC,
        publicPI: arrPublicPI
      });
    })
    .catch(error=>{
      console.error(error);
    })
  }

  render(){
    let id = this.props.match.params.id
    if(id && (this.state.data.length > 0 || this.state.publicOMC.length > 0 || this.state.publicPI.length > 0)){
      const newArr = this.state.data.concat(this.state.publicOMC).concat(this.state.publicPI)
      const res = newArr.filter(item=>item.id === id)[0];
      const detalleRes = {
        state:{
          props: {
            fromTitle:"Publicaciones",
            fromLink:"/publicaciones",
            mainState:{
              ...res
            }
          }
        }
      }
      return (<Detalle location={detalleRes} />);
    } else {
      return (
        <Publicaciones cards={this.state.data}
                       publicOMC={this.state.publicOMC}
                       publicPI={this.state.publicPI} />
      );  
    }
  }
}

export default WithData;
